export default __webpack_public_path__ + "static/media/how-arrow-tablet.43f6aad9.svg";